import React, { ChangeEvent, FC } from 'react';
import { Grid, Typography } from '@material-ui/core';

import { ValidatedSwitch } from 'components';

interface IProps {
  value: string;
  title: string;
  description: string;
  checkedFn?: (value: unknown) => boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: boolean) => void;
}

const GroupSwitch: FC<IProps> = ({ value, title, description, checkedFn, onChange }) => (
  <Grid item container alignItems="center" justify="space-between">
    <Grid item xs={12} sm={4}>
      <Typography variant="body2" display="inline">
        {title}
      </Typography>
    </Grid>
    <Grid item xs={12} sm container justify="flex-end">
      <Grid item>
        <ValidatedSwitch
          color="default"
          label={description}
          labelPlacement="start"
          name={value}
          checkedFn={checkedFn}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default GroupSwitch;
